import api from '../lib/api';
import type { Paginated } from '../types';
import type { OperatorCallTarget, OperatorCallTargetInput } from '../types/crm';

// The single-record endpoints (show/create/update) return a JSON:API-style
// envelope: `{ data: { id, type, attributes: {...flat record...} } }`. List
// endpoints return flat records directly inside `data`.

export const operatorCallTargetService = {
  getAll: async (params?: Record<string, unknown>): Promise<Paginated<OperatorCallTarget>> => {
    const response = await api.get<Paginated<OperatorCallTarget>>('/operator_call_targets', { params });
    return response.data;
  },

  getById: async (id: number): Promise<OperatorCallTarget> => {
    const response = await api.get<{ data: { attributes: OperatorCallTarget } }>(`/operator_call_targets/${id}`);
    return response.data.data.attributes;
  },

  create: async (data: OperatorCallTargetInput): Promise<OperatorCallTarget> => {
    const response = await api.post<{ data: { attributes: OperatorCallTarget } }>('/operator_call_targets', {
      operator_call_target: data,
    });
    return response.data.data.attributes;
  },

  update: async (id: number, data: Partial<OperatorCallTargetInput>): Promise<OperatorCallTarget> => {
    const response = await api.patch<{ data: { attributes: OperatorCallTarget } }>(`/operator_call_targets/${id}`, {
      operator_call_target: data,
    });
    return response.data.data.attributes;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/operator_call_targets/${id}`);
  },
};

export default operatorCallTargetService;
